export const UPLOAD_PROOF_REQUEST = 'UPLOAD_PROOF_REQUEST';
export const UPLOAD_PROOF_FAILURE = 'UPLOAD_PROOF_FAILURE';
export const UPLOAD_PROOF_SUCCESS = 'UPLOAD_PROOF_SUCCESS';
export const DELETE_PROOF_FILE_REQUEST = 'DELETE_PROOF_FILE_REQUEST';
export const DELETE_PROOF_FILE_SUCCESS = 'DELETE_PROOF_FILE_SUCCESS';
